<template>
  <div>
    <Row>
      <Form ref="queryDictTypeForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('system.dict-type.label.label')" prop="label">
            <Input v-model="query.label" :placeholder="$t('system.dict-type.label.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('system.dict-type.sign.label')" prop="sign">
            <Input v-model="query.sign" :placeholder="$t('system.dict-type.sign.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('system.dict-type.status.label')" prop="status">
        <Select v-model="query.status" clearable filterable :placeholder="$t('system.dict-type.status.holder')">
          <Option v-for="item in $t('system.dict-type.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openDictTypeDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="dictTypeTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
<!--        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.dictTypeTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>-->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="dictTypeDrawer" :title="this.$t('drawer.title')[dictTypeDrawer.type]" :visible.sync="dictTypeDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <dictType-form ref="dictTypeForm"/>
        <div class="right-drawer__footer" v-if="dictTypeDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="dictTypeDrawer.submiting">{{ dictTypeDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="dictTypeDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import DictTypeForm from '@/views/system/dict-type/components/Form.vue';
Vue.component('dictType-form', DictTypeForm);

export default {
  name: 'aip-system-dictType-index',
  mixins:[mixin],
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      dictTypeDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.system.DictType.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openDictTypeDrawer(dictType){
      this.dictTypeDrawer.visible = true
      this.dictTypeDrawer.type = dictType ? dictType.type : 'add'
      this.$nextTick(()=>{
          if(dictType){
              this.$refs['dictTypeForm'].getDictType(dictType.id,dictType.type)
          }else{
            this.$refs['dictTypeForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.dictTypeDrawer.submiting = true;
        this.$refs.dictTypeForm.handleSubmit(
          data=>{
            this.dictTypeDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.dictTypeDrawer.visible=false, 1000);
          },
          ()=>{
            this.dictTypeDrawer.submiting = false;
          }
        )
    },
    deleteDictType(id){
      api.system.DictType.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.system.DictType.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          /*{key: 'id', width: 60, fixed:'left',type:'selection'},*/

          {key: 'label', align:'center',minWidth: 180,fixed:'left', title:  this.$t('system.dict-type.label.label')},
          {key: 'sign', align:'center',minWidth: 180, title:  this.$t('system.dict-type.sign.label')},
          {
            key: 'status',
            align: 'center',
            width: 120,

            column:'status',
            filters: this.$t('system.dict-type.status.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.status = value
              this.handleSearch();
            },
            title: this.$t('system.dict-type.status.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.status==t.value).label}</div>
            }
          },
          {key: 'remark', align:'center',minWidth: 300, title:  this.$t('system.dict-type.remark.label')},
          {key: 'createTime', align: 'center', width:200, title: this.$t('system.dict-type.createTime.label'),},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 180,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openDictTypeDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openDictTypeDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteWebSite(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
